// extracted by css-extract-rspack-plugin
export default {"skeletonBox":"skeletonBox-EtEM3I"};